<template>
	<router-view />
</template>

<script>
export default {
	name: "ReservationsContainer"
}
</script>

<style scoped lang="scss">

</style>